import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const VehicleSelectorAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "vehicle-selector" */ './vehicle-selector'),
  componentName: 'VehicleSelector',
});
